(function () {
  var el = document.getElementById("ThemeStringsData");
  if (el) {
    try {
      window.themeStrings = JSON.parse(el.textContent);
    } catch (e) {}
  }
  window.themeStrings = window.themeStrings || {};
})();

document.addEventListener("DOMContentLoaded", () => {
  const headerLabels =
    (window.themeStrings && window.themeStrings.header) || {};
  const menuToggle = document.querySelector(".header__menu-toggle");
  const headerMenu = document.getElementById("HeaderMenu");
  const headerMenuBackdrop = document.getElementById("HeaderMenuBackdrop");
  const headerMenuClose = document.querySelector(".header__menu-close");

  if (menuToggle && headerMenu) {
    const iconBars = menuToggle.querySelector(".icon-bars");
    const iconClose = menuToggle.querySelector(".icon-close");
    const mobileMenuQuery = window.matchMedia("(max-width: 749px)");

    function setMenuState(isOpen) {
      menuToggle.setAttribute("aria-expanded", String(isOpen));
      if (mobileMenuQuery.matches) {
        headerMenu.setAttribute("aria-hidden", String(!isOpen));
      } else {
        headerMenu.removeAttribute("aria-hidden");
      }
      headerMenu.classList.toggle("is-open", isOpen);
      headerMenuBackdrop &&
        headerMenuBackdrop.classList.toggle("is-visible", isOpen);
      document.body.classList.toggle("menu-is-open", isOpen);

      if (iconBars && iconClose) {
        if (isOpen) {
          iconBars.style.display = "none";
          iconClose.style.display = "";
          menuToggle.setAttribute(
            "aria-label",
            headerLabels.closeMenu || "Close menu",
          );
        } else {
          iconBars.style.display = "";
          iconClose.style.display = "none";
          menuToggle.setAttribute(
            "aria-label",
            headerLabels.openMenu || "Open menu",
          );
        }
      }
    }

    menuToggle.addEventListener("click", () => {
      const isExpanded = menuToggle.getAttribute("aria-expanded") === "true";
      setMenuState(!isExpanded);
    });

    headerMenuClose &&
      headerMenuClose.addEventListener("click", () => setMenuState(false));
    headerMenuBackdrop &&
      headerMenuBackdrop.addEventListener("click", () => setMenuState(false));

    headerMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setMenuState(false));
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setMenuState(false);
    });

    mobileMenuQuery.addEventListener("change", () => setMenuState(false));
    if (mobileMenuQuery.matches) headerMenu.setAttribute("aria-hidden", "true");
  }
});

// Slider scroll-snap con dots y autoplay
function initCustomSlider(wrapper) {
  if (wrapper.dataset.sliderInitialized === "true") return;
  wrapper.dataset.sliderInitialized = "true";

  const slider = wrapper.querySelector(".image-slider");
  const dots = wrapper.querySelectorAll(".slider-dot");
  const slides = wrapper.querySelectorAll(".image-slider__slide");
  if (!slider || !dots.length || !slides.length) return;

  let current = 0;
  let timer = null;
  const autoplay = parseFloat(wrapper.dataset.sliderAutoplay) || 5;

  function goTo(idx) {
    current = idx;
    slider.scrollTo({ left: slider.offsetWidth * idx, behavior: "smooth" });
    dots.forEach((dot, i) => dot.classList.toggle("active", i === idx));
  }

  dots.forEach((dot, idx) => {
    dot.addEventListener("click", function () {
      goTo(idx);
      resetAutoplay();
    });
  });

  function nextSlide() {
    goTo((current + 1) % slides.length);
  }

  function startAutoplay() {
    stopAutoplay();
    if (autoplay > 0) {
      timer = setInterval(nextSlide, autoplay * 1000);
    }
  }
  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }
  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  // Actualiza el dot activo al hacer scroll manual
  slider.addEventListener("scroll", function () {
    const idx = Math.round(slider.scrollLeft / slider.offsetWidth);
    dots.forEach((dot, i) => dot.classList.toggle("active", i === idx));
    current = idx;
  });

  goTo(0);
  startAutoplay();
}

// Inicializa todos los sliders
window.addEventListener("DOMContentLoaded", function () {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(
      function () {
        document
          .querySelectorAll(".image-slider-wrapper")
          .forEach(initCustomSlider);
      },
      { timeout: 2000 },
    );
  } else {
    setTimeout(function () {
      document
        .querySelectorAll(".image-slider-wrapper")
        .forEach(initCustomSlider);
    }, 200);
  }
});
